// Footer.jsx
import React from 'react';
import { Trash2, Facebook, Twitter, Instagram, Linkedin } from 'lucide-react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-grid">
          <div className="footer-brand">
            <div className="footer-logo">
              <Trash2 size={32} className="logo-icon" />
              <h2 className="brand-name">BinBuddy</h2>
            </div>
            <p className="footer-description">
              Revolutionizing waste management across India with smart technology and sustainable solutions.
            </p>
            <div className="footer-socials">
              <a href="#facebook" className="social-icon" aria-label="Facebook">
                <Facebook size={20} />
              </a>
              <a href="#twitter" className="social-icon" aria-label="Twitter">
                <Twitter size={20} />
              </a>
              <a href="#instagram" className="social-icon" aria-label="Instagram">
                <Instagram size={20} />
              </a>
              <a href="#linkedin" className="social-icon" aria-label="LinkedIn">
                <Linkedin size={20} />
              </a>
            </div>
          </div>

          <div className="footer-links">
            <h3>Quick Links</h3>
            <ul>
              {['Home', 'About', 'Features', 'Map', 'Contact'].map((item) => (
                <li key={item}>
                  <a href={`#${item.toLowerCase()}`}>{item}</a>
                </li>
              ))}
            </ul>
          </div>

          <div className="footer-links">
            <h3>Our Services</h3>
            <ul>
              {[
                'Smart Bin Management',
                'Route Optimization',
                'Waste Analytics',
                'Fleet Management',
                'Municipal Partnerships'
              ].map((item) => (
                <li key={item}>
                  <a href="#features">{item}</a>
                </li>
              ))}
            </ul>
          </div>

          <div className="footer-subscribe">
            <h3>Subscribe</h3>
            <p>Stay updated with our latest news and developments</p>
            <form className="subscribe-form">
              <input type="email" placeholder="Your email address" />
              <button type="submit">Subscribe</button>
            </form>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} BinBuddy. All rights reserved.</p>
          <ul>
            {['Privacy Policy', 'Terms of Service', 'Sitemap'].map((item) => (
              <li key={item}>
                <a href="#">{item}</a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
